// WithPageStatus.jsx
import React from 'react';
import PropTypes from 'prop-types';

export class WithPageStatus extends React.PureComponent {
  render() {
    const {
      isCurrentPageFetching,
      isFirstPageFetching,
      isNextPageFetching,
      nextPage,
    } = this.props;

    return this.props.children({
      isCurrentPageFetching,
      isFirstPageFetching,
      isNextPageFetching,
      nextPage,
    });
  }
}

WithPageStatus.propTypes = {
  children: PropTypes.func.isRequired,
  isCurrentPageFetching: PropTypes.bool,
  isFirstPageFetching: PropTypes.bool,
  isNextPageFetching: PropTypes.bool,
  nextPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

WithPageStatus.defaultProps = {
  isNextPageFetching: false,
  isFirstPageFetching: false,
  isCurrentPageFetching: false,
  nextPage: null,
};

export default WithPageStatus;
